import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router';

import styles from './AutoPlayMinimizedDetail.scss';

const messages = defineMessages({
  startingIn: {
    defaultMessage: 'Starting in {seconds}s',
    description: 'starting in an amount of seconds',
  },
  playingNext: {
    defaultMessage: 'Playing Next',
    description: 'indicates that a video is playing after the current video ends',
  },
});

export interface AutoPlayMinimizedDetailProps {
  title: string,
  toUrl: string,
  onLinkClick: (e: React.MouseEvent) => void,
  counter?: number,
  compactAutoplayUiMode: boolean
}

const AutoPlayMinimizedDetail: React.FunctionComponent<AutoPlayMinimizedDetailProps> = ({
  title,
  toUrl,
  onLinkClick,
  counter,
  compactAutoplayUiMode,
}) => {
  const intl = useIntl();
  const handleLinkClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onLinkClick(event);
  };

  return (
    <div className={classNames(styles.minimizedDetail)} data-test-id="autoplay-minimized">
      <div className={classNames(styles.title, styles.compactAutoplayUiMode)}>
        <Link onClick={handleLinkClick} to={toUrl}>
          {title}
        </Link>
      </div>
      {compactAutoplayUiMode ? (
        <div className={styles.counter}>{intl.formatMessage(messages.startingIn, { seconds: counter })}</div>
      ) : (
        <div className={styles.prompt}>{intl.formatMessage(messages.playingNext)}</div>
      )}
    </div>
  );
};
export default AutoPlayMinimizedDetail;
